<template>
  <label class="inline-flex h-[34px] items-center gap-2 whitespace-nowrap text-sm text-gray-700">
    <!-- A checkbox for a filter bar, at the height of a FilterDropdown box so it lines up with the boxes. -->
    <input :checked="modelValue" type="checkbox" class="rounded border-gray-300" @change="$emit('update:modelValue', $event.target.checked)">
    {{ label }}
  </label>
</template>

<script>
export default {
  name: 'FilterCheckbox',
  props: {
    label: { type: String, required: true },
    modelValue: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
};
</script>
